module.exports = __webpack_public_path__ + "img/nanemp.ccd438c6.jpg";